import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/**
 * The heading over one section of a searchable picker.
 *
 * Deliberately identical to `ComboboxLabel` (`ui/combobox.tsx`), this design
 * system's established group-label treatment — a workflow config panel can show
 * three sectioned dropdowns at once (Variables, Examples, "What should the AI
 * read?") and they must all separate their sections the same way.
 *
 * It has to be a component rather than a class on the group, because cmdk
 * renders `CommandGroup`'s `heading` into an element only `ui/command.tsx` can
 * reach — and that file's `[cmdk-group-heading]` rules dress EVERY Command in
 * the app. Styling the passed element is what keeps this opt-in.
 */
export function PickerGroupHeading({
    label,
    icon,
    className,
}: {
    readonly label: string;
    /** Optional leading glyph. Sections that are pure prose headings omit it. */
    readonly icon?: ReactNode;
    readonly className?: string;
}) {
    return (
        <span
            className={cn(
                'text-text-secondary flex items-center gap-1.5 text-xs font-semibold tracking-wide uppercase',
                className,
            )}
        >
            {icon}
            {label}
        </span>
    );
}
